import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography } from '@albo-ui/core';

export type SessionClosedProps = {
    onClose: () => void;
    open: boolean;
    title: string;
    message: string;
}

export const SessionClosed = ({ onClose, open, title, message }: SessionClosedProps) => {
	
	return (
		<Dialog onClose={onClose} open={open} >
			<DialogTitle>
				<Typography variant="h2">{title}</Typography>
			</DialogTitle>
			<DialogContent>
				<FlexGrid direction="column" alignItems='flex-start' spacing={2} fullHeight fullWidth>
					<Typography variant="paragraph">{message}</Typography>
				</FlexGrid>
			</DialogContent>

			<DialogActions>
				<FlexGrid container fullHeight fullWidth style={{ marginTop: '20px', justifyContent: 'end' }}>
					<Button onClick={onClose} size='normal' >
						Aceptar
					</Button>				
				</FlexGrid>
			</DialogActions>
		</Dialog>
	)
}